import * as PeopleTypes from "../types/people.types";
import * as UiTypes from "../types/ui.types";
import axiosInstance from "../../api";
import { alertActions } from "./alert.actions";
import { Dispatch } from "redux";
import { ThunkDispatchType } from "../store";

export const loadPeople =
  (page: number | string, filter?: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: PeopleTypes.LOADING_PEOPLE });

    axiosInstance
      .get("/user/", { params: filter })
      .then((res) => {
        dispatch({
          type: PeopleTypes.LOAD_PEOPLE,
          payload: res.data,
        });
        dispatch({ type: UiTypes.CLEAR_ERRORS });
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Network Issue",
          });
        }
      });
  };

export const getPeople = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: PeopleTypes.FETCH_PEOPLE_REQUEST });

  axiosInstance
    .get("user/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: PeopleTypes.FETCH_PEOPLE_REQUEST_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err?.response?.data?.detail?.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err?.response?.data?.detail?.toString(),
        });
      }
    });
};

export const trashPeople = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .delete("/user/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch(alertActions.success("Delete success"));

      dispatch(loadPeople(1));
    })
    .catch((err) => {
      dispatch(alertActions.showError(err, "Error while delete."));
    });
};

export const blukTrashPeople = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .delete("/user/", id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch(alertActions.success("Delete success"));

      dispatch(loadPeople(1));
    })
    .catch((err) => {
      dispatch(alertActions.showError(err, "Error while delete."));
    });
};

export const updatePeople = (userData: any, id: number) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: PeopleTypes.PEOPLE_SAVE_REQUEST });

  axiosInstance
    .put("user/" + id, userData)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({ type: PeopleTypes.PEOPLE_SAVE_SUCCESS });
      dispatch(alertActions.success("Updated Successfully"));
      dispatch(loadPeople(1));
    })
    .catch((err) => {
      dispatch(alertActions.showError(err, "Error updating data"));
    });
};

export const addStaff = (userData: any, id: number) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: PeopleTypes.PEOPLE_SAVE_REQUEST });

  axiosInstance
    .post("user/", userData)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({ type: PeopleTypes.PEOPLE_SAVE_SUCCESS });
      dispatch(alertActions.success("Staff added Successfully"));
      dispatch(loadPeople(1));
    })
    .catch((err) => {
      dispatch({ type: UiTypes.LOADING_UI_SUCCESS });

      dispatch(alertActions.showError(err, "Error submitting"));
    });
};

export const getPeopleProfile = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: PeopleTypes.FETCH_PEOPLE_REQUEST });
  axiosInstance
    .get("user/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: PeopleTypes.FETCH_PEOPLE_REQUEST_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(alertActions.showError(err, "Error occured"));
    });
};

export const updatePeopleProfile =
  (userData: any, id: number) => (dispatch: any) => {
    dispatch({ type: PeopleTypes.PROFILE_SAVE_REQUEST });

    // userData.set('infos', JSON.parse(userData.get('infos')));

    axiosInstance
      .put("user/" + id, userData)
      .then((res) => {
        dispatch(alertActions.success("People Updated Successfully"));
        dispatch({ type: PeopleTypes.PROFILE_SAVE_SUCCESS, payload: res.data });
        dispatch(getPeopleProfile(id));
      })

      .catch((err) => {
        dispatch(alertActions.showError(err, "Error submitting"));

        dispatch({
          type: PeopleTypes.PROFILE_SAVE_SUCCESS_FAILED,
        });
      });
  };

export const updatePeopleStatus =
  (userData: any, id: string) => (dispatch: any) => {
    dispatch({ type: PeopleTypes.PROFILE_SAVE_REQUEST });

    axiosInstance
      .put("user/status/" + id, userData)
      .then((res) => {
        dispatch(alertActions.success("Updated Successfully"));
        dispatch({ type: PeopleTypes.PROFILE_SAVE_SUCCESS });
        getPeopleProfile(id);
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err?.response?.data?.detail?.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err?.response?.data?.detail?.toString(),
          });
        }
      });
  };

export const updatePeopleProfilePicture =
  (userData: any, id: number) => (dispatch: any) => {
    dispatch({ type: PeopleTypes.PROFILE_AVATAR_SAVE_REQUEST });

    axiosInstance
      .put("user/avatar/" + id, userData)
      .then((res) => {
        dispatch(alertActions.success("Profile picture Updated Successfully"));
        dispatch({ type: PeopleTypes.PROFILE_AVATAR_SAVE_SUCCESS });
        getPeopleProfile(id);
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err?.response?.data?.detail?.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err?.response?.data?.detail?.toString(),
          });
        }
      });
  };

export const trashCustomfield = (did: any, uid: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .delete("/user/delete/" + did + "/" + uid)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch(alertActions.success("Delete success"));
      dispatch(getPeopleProfile(uid));
    })
    .catch((err) => {
      dispatch(alertActions.showError(err, "Error while delete."));
    });
};

export const sendAttachment = (userData: object) => (dispatch: Dispatch) => {
  dispatch({ type: PeopleTypes.SEND_MAIL });
  axiosInstance
    .post("/user/sendattachment", userData)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch(alertActions.success(res.data.message));
      dispatch({ type: PeopleTypes.SEND_MAIL_SUCCESS });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const loadFacitlies = () => (dispatch: any) => {
  dispatch({ type: PeopleTypes.FETCH_PEOPLE_ROOT_FACILITY_REQUEST });
  axiosInstance
    .get("/timesheet/facilities")
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: PeopleTypes.PEOPLE_EMPLOYEE_FACILITIES,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const loadFacility = (id: any) => (dispatch: any) => {
  dispatch({ type: PeopleTypes.FETCH_PEOPLE_ROOT_FACILITY_REQUEST });

  axiosInstance
    .get("facility/rootfacility/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: PeopleTypes.FETCH_PEOPLE_ROOT_FACILITY_REQUEST_SUCCESS,
        payload: res.data.root_facility,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err?.response?.data?.detail?.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err?.response?.data?.detail?.toString(),
        });
      }
    });
};

export const timesheetLimitWarn =
  (id: string, data: any, page: number, filterData: any) =>
  (dispatch: ThunkDispatchType) => {
    dispatch({ type: PeopleTypes.PROFILE_SAVE_REQUEST });

    axiosInstance
      .put("user/timesheet-limit-warn/" + id, data)
      .then((res) => {
        dispatch(alertActions.success("Updated Successfully"));
        dispatch({ type: PeopleTypes.PROFILE_SAVE_SUCCESS });
        dispatch(loadPeople(page, filterData));
      })
      .catch((err) => {
        if (err?.response?.status === 0) {
          dispatch(alertActions.error("Network Error"));

          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else if (err?.message) {
          dispatch(alertActions.error(err?.message?.toString()));
        } else {
          dispatch(alertActions.error(err?.response?.data?.detail?.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err?.response?.data?.detail?.toString(),
          });
        }
      });
  };
